import { post, get } from '../../../../services/request';

//--------------------Edit Provider Profile Start -----------------//
 
// Get Provider Profile By ID
export const getRadiologistByID = (radiologistID) => {
    return get(`Radiologist/GetRadiologistByID?RadiologistID=${radiologistID}`);
};

// // Get Provider Profile Contract Summary By ID
// export const getRadiologistContractSummaryByID = (radiologistID) => {
//     return get(`Compensation/GetCompensationSummaryTextByRadId?RadiologistId=${radiologistID}`);
// };

// Get Provider Profile Contract Documents By Contract ID
export const getRadiologistContractDocumentsByContractID = (contractSummaryID) => {
    return get(`Compensation/GetCompensationBlobUrlByContractId?ContractSummaryID=${contractSummaryID}`);
};

// Save Radiologist (create/update)
export const saveRadiologist = (payload) => {
    return post('Radiologist/SaveRadiologist', payload);
};

export const markUnassignedProviderAssigned = (payload) => {
    return post('Radiologist/MarkUnassignedProviderAssigned', payload);
};
// Get City State by ZipCode
export const getCityStateByZipCode = (zipCode) => {
    return get(`Common/GetCityStateByZipCode?ZipCode=${zipCode}`);
};
 
// Save Radiologist Note
export const saveRadiologistNote = (payload) => {
    return post('Radiologist/SaveRadiologistNote', payload);
};

// Save Radiologist Tags
export const saveRadiologistTags = (payload) => {
    return post('Radiologist/SaveRadiologistTags', payload);
};
 
// Get Week Rotation Template by ID
export const getWeekRotationTemplateById = (weekRotationTemplateID) => {
    return get(`WeekRotationTemplate/GetWeekRotationTemplateByID?WeekRotationTemplateID=${weekRotationTemplateID}`);
};
 
// Save Schedule Week Rotation
export const saveScheduleWeekRotation = (payload) => {
    return post('Radiologist/SaveScheduleWeekRotation', payload);
};
 
//--------------------Edit Provider Profile End -----------------//


// Rate Card
export const getRateCardDetailsByRadId = (radiologistID) => {
    return get(`ForecastingPayroll/GetRadRateCardDetails?radiologistId=${radiologistID}`);
};

// Provider Assignments
export const getRadiologistAssignmentsDropdown = (radiologistID) => {
    return get(`Radiologist/GetRadiologistSkillDropdown?RadiologistID=${radiologistID}`);
};

export const getRadiologistAssignmentsById = (radiologistID) => {
    return get(`Radiologist/GetRadiologistSkillDetailByID?RadiologistID=${radiologistID}`);
};

export const saveRadiologistAssignments = (payload) => {
    return post('Radiologist/SaveRadiologistSkills', payload);
};

export const deleteRadiologistAssignment = (payload) => {
    return post('Radiologist/DeleteRadiologistSkillDetails', payload);
};

// Rad Document Types Dropdown
export const getRadDocumentTypes = () => {
    return get('RadDocumentType/GetAllRadDocumentType');
};

// Rad Note Types Dropdown
export const getRadNoteTypes = () => {
    return get('RadNoteType/GetAllRadNoteType');
};

// Active Home State License Dropdown
export const getActiveHomeStateLicenseDropdown = (radiologistID = 0) => {
    return get(`Radiologist/GetActiveHomeStateLicenseDropdown?RadiologistID=${radiologistID}`);
};

// Rad Document Management
export const getRadDocumentsByRadId = (payload) => {
    return post('Radiologist/GetRadDocumentsByRadId', payload);
};

export const uploadRadDocument = (formData) => {
    return post('Radiologist/UploadRadDocument', formData);
};

export const deleteRadDocument = (payload) => {
    return post('Radiologist/DeleteRadDocument', payload);
};

export const downloadRadDocument = (payload) => {
    return post('Radiologist/DownloadRadDocument', payload);
};